require([
  'jquery',
  'jquery-treegrid/js/jquery.treegrid.js',
  'fancybox/dist/js/jquery.fancybox.js'
], Jquery => {
  const $ = Jquery;
  const globals = window.serverData;

  const breadcrumb = $('.breadcrumb');
  const articleWrap = $('.documentation-article-wrap');
  const articleName = $('.documentation-article-name');
  const query = $('#query');

  $('.documentation').on('click', '.related-link', event => {
    event.preventDefault();
    window.location.hash = `/${event.currentTarget.dataset.unique}`;
  });

  $('.documentation').on('click', '.treegrid-expander', event => {
    event.stopPropagation();
  });

  $('.documentation').on('click', '.docs-root', () => {
    $('.tree-active').removeClass('tree-active');
    $('.tree').treegrid('collapseAll');
  });

  $('#docs-search').submit(event => {
    event.preventDefault();
    $('.tree-active').removeClass('tree-active');
    $('.tree').treegrid('collapseAll');
    window.location.hash = '/';
    $.ajax({
      type: 'POST',
      url: `${globals._uri}/documentation/find/`,
      data: {
        _method: 'ajax',
        query: query.val(),
        published: 1
      }
    })
      .done(response => {
        articleWrap.html(
          $('<div/>')
            .attr('class', 'results')
            .append(
              $('<h5/>').append('Search results:'),
              $('<ul/>').append(
                response.data.map(subsection =>
                  $('<li/>').append(
                    $('<a/>')
                      .attr({
                        class: 'related-link',
                        'data-unique': subsection.unique
                      })
                      .append(subsection.name)
                  )
                )
              )
            )
        );
      })
      .fail(response => {
        articleName.html('');
        articleWrap.html(
          $('<div/>')
            .attr('class', 'alert alert-danger')
            .append(response.responseJSON.error[0])
        );
      });
  });

  $('.tree')
    .treegrid({
      initialState: 'collapsed',
      expanderExpandedClass: 'icon down-open-mini',
      expanderCollapsedClass: 'icon down-open-mini rotated'
    })
    .on('collapse', event => {
      event.stopPropagation();
      $(event.target).removeClass('expanded');
    })
    .on('expand', event => {
      event.stopPropagation();
    });

  const setCrumbs = response => {
    breadcrumb.html(
      response.data.crumbs.map(crumb => {
        $(`.treegrid-${crumb.unique}`).addClass('expanded');
        return $('<li/>').append(
          $('<a/>')
            .attr({
              class: 'no-underline crumb related-link',
              'data-unique': crumb.unique
            })
            .append(crumb.name)
        );
      })
    );

    $('.tree-active').removeClass('tree-active');
    $(`.treegrid-${response.data.section.unique}`).addClass('expanded tree-active');

    breadcrumb.prepend(
      $('<li/>').append(
        $('<a/>')
          .attr({
            href: globals._uri,
            class: 'no-underline'
          })
          .append('<span class="icon home"></span> Home')
      ),
      $('<li/>').append(
        $('<a/>')
          .attr({
            href: `${globals._uri}/documentation/`,
            class: 'no-underline docs-root'
          })
          .append('Documentation')
      )
    );

    breadcrumb.append(
      $('<li/>')
        .attr('class', 'active')
        .append(response.data.section.name)
    );

    const expanded = $('.expanded');
    const treeActive = $('.tree-active');

    if (expanded.length > 0) {
      $('.expanded').treegrid('expand');
    }

    if (treeActive.length > 0) {
      $('.tree-active').treegrid('expand');
    }
  };

  const getSectionByUnique = () => {
    $.ajax({
      type: 'POST',
      url: `${globals._uri}/documentation/getSectionByUnique/`,
      data: { _method: 'ajax', _element: window.location.hash.substring(2) }
    })
      .done(response => {
        setCrumbs(response);
        articleName.html(response.data.section.name);
        if (response.data.section.text) {
          articleWrap.html(`<div itemprop="articleBody">${response.data.section.text}</div>`);
          $('.documentation-article-wrap img')
            .each(() => {
              $(this).attr('data-fancybox-group', 'gallery');
            })
            .fancybox();
        } else {
          articleWrap.html('<div class="text-muted">No text.</div>');
        }
        if (response.data.section.subsections && response.data.section.subsections.length) {
          if (!window.location.hash) {
            window.location.hash = `/${response.data.section.subsections[0].unique}`;
          }

          articleWrap.append(
            $('<div/>')
              .attr('class', 'related')
              .append(
                $('<hr/>'),
                $('<h5/>').append('Related articles:'),
                $('<ul/>').append(
                  response.data.section.subsections.map(subsection =>
                    $('<li/>').append(
                      $('<a/>')
                        .attr({
                          class: 'related-link',
                          'data-unique': subsection.unique
                        })
                        .append(subsection.name)
                    )
                  )
                )
              )
          );
        }

        articleWrap.append(
          `<div style="display:none;"><div itemprop="datePublished">${response.data.section.lastModifiedDate}</div><a href="${globals._uri}/public/images/logo.png" itemprop="image"></a></div>`
        );
        articleWrap.append(
          '<div style="display:none;" itemprop="author" itemscope itemtype ="http://schema.org/Organization"><span itemprop="legalName">Holdshort Aviation Systems, LLC</span><span itemprop="email">support@holdshort.com</span><span itemprop="telephone">+1 775-364-0660</span><img url="{{ _uri }}/public/images/logo.png" alt="Holdshort Aviation Systems, LLC" title="Holdshort Aviation Systems, LLC" itemprop="logo"><a href="{{ _uri }}" itemprop="url"></a><div itemprop="description">Aircraft Scheduling Software for Flight Schools, FBOs, Aircraft Clubs & Partnerships. Try it free for 60 days. Top-rated flight scheduler app.</div></div>'
        );
        $('title').html(
          `${
            response.data.section.metatitle.length > 0
              ? response.data.section.metatitle
              : 'Documentation'
          } - Holdshort`
        );
        $('meta[name=keywords]').attr('content', response.data.section.metakeys);
        $('meta[name=description]').attr('content', response.data.section.metadescr);
      })
      .fail(response => {
        articleName.html('');
        articleWrap.html(
          $('<div/>')
            .attr('class', 'alert alert-danger')
            .append(response.responseJSON.error[0])
        );
      });
  };

  if (window.location.hash) {
    if (window.location.hash !== '#/') {
      getSectionByUnique();
    }
  } else {
    getSectionByUnique();
  }

  $(window).on('hashchange', () => {
    if (window.location.hash !== '#/') {
      getSectionByUnique();
    }
  });
});
